<template>
  <WizardContent
    :show-sidebar="false"
    class="wizard-wrapper"
  >
    <GateHeader>
      <template #logo>
        <JobNavIcon />
      </template>
      <template #page-title>
        Welcome to JobNav!
      </template>
    </GateHeader>
    <p class="text-body-2 mb-6">
      Verify your email by following the link we've sent to the email address you provided.
    </p>
    <p class="text-body-2 mb-6">
      Check your spam folder if the email is taking too long to show up in your inbox or
      <button
        type="button"
        class="text-linkDefault"
        @click="resendVerificationEmail"
      >
        resend it by clicking here.
      </button>
    </p>
    <p class="text-body-2 mb-6">
      Having trouble?
      <a
        class="text-decoration-underline text-linkDefault"
        :href="'mailto:hello@datapeople.io'
          + '?subject=Having%20issues%20verifying%20email%20on%20JobNav'"
      >
        Contact support.
      </a>
    </p>
  </WizardContent>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import { signupResendVerificationEmail } from '@/api/signup';
import WizardContent from '@/components/shared/WizardContent.vue';
import GateHeader from '@/components/shared/gates/GateHeader.vue';
import JobNavIcon from '@/assets/jobnav-payscale-icon-logo.svg?component';

export default {
  name: 'VerifyEmail',
  components: {
    WizardContent,
    GateHeader,
    JobNavIcon,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'email']),
  },
  created() {
    this.updateFlash({ status: 'success', message: 'Email sent! Please check and confirm.' });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Verify Email' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
    async resendVerificationEmail() {
      try {
        this.resetFlash();
        await signupResendVerificationEmail();
        this.updateFlash({ status: 'success', message: 'Verification email resent!' });
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
      }
    },
  },
};
</script>

<style scoped lang="less">
.wizard-wrapper {
  min-width: 330px;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.resend-anchor {

  &:hover {
    cursor: pointer;
  }
}
</style>
